
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import Buchungsprotokoll from '@/components/Lagerfuehrung/Buchungsprotokoll.vue';
    import Buchung from '@/components/Lagerfuehrung/Buchung.vue';
    import Lagerliste from '@/components/Lagerfuehrung/Lagerliste.vue';
    import LagerlisteJeCharge from '@/components/Lagerfuehrung/LagerlisteJeCharge.vue';
    import Impfstoff from '@/types/Impfstoffe';
    import { LagerfuehrungFilter, LoadImpfstoffePayload } from '@/store/lagerfuehrung';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            Buchung,
            Buchungsprotokoll,
            Lagerliste,
            LagerlisteJeCharge,
        },
        computed: {
            ...mapState('lagerfuehrung', ['filters', 'dialogs', 'loaders', 'impfstoffliste']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapGetters('authentication', ['isAllowed']),
        },
        methods: {
            ...mapActions('lagerfuehrung', [
                'loadImpfstoffe',
                'setImpfstoff',
                'loadLagerliste',
                'loadLagerlisteJeCharge',
                'setDialogs',
                'exportLagerlisteGesamt'
            ]),
        },
    })
    export default class Lagerfuehrung extends Vue {
        public selectedImpfstoff: Impfstoff[] = [];
        public search = '';

        public setImpfstoff!: (impfstoff: Impfstoff | null) => void;
        public loadImpfstoffe!: (payload?: LoadImpfstoffePayload) => void;

        public filter: LagerfuehrungFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Impfstoff> {
            return [
                { text: 'Impfstoff', value: 'impfstoff' },
                { text: 'Verkaufspreis', value: 'verkaufspreis' },
                { text: 'Lagerbestand', value: 'lagerbestand' },
                { text: 'Anmerkung', value: 'anmerkung' },
            ];
        }

        public mounted(): void {
            this.loadImpfstoffe({ filter: this.filter });
        }

        @Watch('selectedImpfstoff')
        public setSelectedImpfstoff(): void {
            this.setImpfstoff(this.selectedImpfstoff[0] ?? null);
        }

        @Watch('filter', { deep: true })
        public onChangeFilter(): void {
            this.selectedImpfstoff = [];
        }

        @Watch('dialogs.buchung')
        public onChangeDialogsBuchung(visible: boolean): void {
            if (!visible) {
                this.selectedImpfstoff = [];
                this.loadImpfstoffe({ filter: this.filter });
            }
        }
    }
